import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthApi } from 'sham-components/services';
import { ResetPasswordPayload } from 'sham-components/shared/models/auth';

@Injectable()
export class ResetPasswordManager {
  private readonly authApi = inject(AuthApi);

  async submitForm(
    payload: ResetPasswordPayload,
    submitError: any,
    submitSuccess: any,
    loading: any,
  ) {
    try {
      await firstValueFrom(this.authApi.resetPassword(payload));
      submitSuccess.set(true);
    } catch {
      submitError.set(
        'Unable to reset password. The link may be invalid or expired.',
      );
    } finally {
      loading.set(false);
    }
  }
}
